/**
 * 시스템 브라우저로 강제 이동시키되, 일부 비공식 스킴이 무동작으로 끝날 때를
 * 감지해서 fallback을 호출.
 *
 * - 표준 우회 스킴(`intent://`, `kakaotalk://web/openExternal`,
 *   `?openExternalBrowser=1`)은 즉시 이동
 * - Naver 비공식 스킴(`naversearchapp://inappbrowser/close`)은 일부 버전에서
 *   동작하지 않을 수 있어 1.5초 후 페이지가 그대로면 onFallback 호출
 *
 * @param url 이동할 URL/스킴
 * @param onFallback 이동 실패 감지 시 호출 (가이드 모달 노출 등)
 */
export function redirectExternalWithFallback(
  url: string,
  onFallback: () => void,
): void {
  const isNaverScheme = url.startsWith("naversearchapp://");
  const before = window.location.href;
  window.location.href = url;

  if (!isNaverScheme) return;

  window.setTimeout(() => {
    // 페이지가 그대로면 스킴이 무시된 것 — fallback 발동.
    if (
      window.location.href === before &&
      document.visibilityState === "visible"
    ) {
      onFallback();
    }
  }, 1500);
}
